/**
 * Language values on request-example summary data are per-record counts.
 * Share must use the sum of those counts — not `num_records` — because the
 * metadata API overwrites `num_records` to the active-row total while
 * `language` can still include archived rows until DatasetInfo is rebuilt.
 */

export function languageRecordTotal(language) {
    if (!language || typeof language !== 'object') return 0;
    return Object.values(language).reduce((sum, count) => {
        const n = Number(count);
        return Number.isFinite(n) ? sum + n : sum;
    }, 0);
}

/**
 * Percentage share of one language, clamped to [0, 100].
 * Returns 0 when there are no language counts.
 */
export function languageSharePercent(count, language) {
    const total = languageRecordTotal(language);
    if (total <= 0) return 0;
    const n = Number(count);
    if (!Number.isFinite(n) || n <= 0) return 0;
    return Math.min(100, (n / total) * 100);
}

/**
 * Denominator for length averages (sum / n). Prefer the language total when
 * it is larger than `num_records` so averages are not inflated by an
 * active-only record count sitting next to all-rows sums.
 */
export function summaryStatsRecordCount(datasetMetaData) {
    const numRecords = Number(datasetMetaData?.num_records) || 0;
    const langTotal = languageRecordTotal(datasetMetaData?.language);
    return Math.max(numRecords, langTotal) || numRecords;
}
